import React from 'react';

const PolitiqueConfidentialitePage = () => {
  return (
    <div className="privacy-page container">
      <h1>Politique de confidentialité</h1>

      <p>
        Le site Vie et couleurs (<a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a>) respecte la vie privée de ses utilisateurs.
      </p>

      <h2>Données collectées</h2>
      <p>
        Lorsque vous utilisez le formulaire de contact, les informations suivantes peuvent être transmises :
      </p>
      <ul>
        <li>votre nom,</li>
        <li>votre prénom,</li>
        <li>votre adresse email,</li>
        <li>votre numéro de téléphone,</li>
        <li>le contenu de votre message.</li>
      </ul>

      <h2>Finalité</h2>
      <p>
        Ces données sont utilisées uniquement afin de répondre à votre demande de contact.
      </p>

      <h2>Conservation</h2>
      <p>
        Les données ne sont pas stockées dans une base de données. Elles sont transmises par email au responsable du site et supprimées une fois la demande traitée.
      </p>

      <h2>Destinataires</h2>
      <p>
        Seul Monsieur Yassine SENANE, éditeur du site, est destinataire de ces informations.
      </p>

      <h2>Vos droits</h2>
      <p>
        Conformément au RGPD et à la loi « Informatique et Libertés », vous disposez des droits suivants :
      </p>
      <ul>
        <li>droit d’accès,</li>
        <li>droit de rectification,</li>
        <li>droit de suppression,</li>
        <li>droit d’opposition au traitement.</li>
      </ul>
      <p>
        Pour exercer vos droits, vous pouvez envoyer un email à : <a href="mailto:senane.yassine44@gmail.com">senane.yassine44@gmail.com</a> ou téléphoner au 07 66 05 98 63.
      </p>
    </div>
  );
};

export default PolitiqueConfidentialitePage;


